export const fr_master = {
    'basket': {
        "sending_to": "Envoyé à:",
        "bonus_balance": "Bonus balance",
        "bonus_data": "Donnée de bonus",
        "valid_for": "valable pour {{bonusValidity}} jours",
        "worth": "<span>La valeur de {{faceValue}} {{sourceCurrencyCode}}</span><br/><span>correspond à {{totalLocalCurrencyAmount}} {{currencyCode}}</span>"
    },
    'login': {
        'register_link': "Nouvel utilisateur",
        'reset_password': 'nouveau mot de passe',
        'preceed_to_login': 'Connexion',
        'link_login': 'Avez vous déjà un compte? Connexion',
        'title_account_verify': 'Verification de compte',
        'resend_code': 'Renvoyé le code',
        'didnt_receive_code': "Vous n'avez pas reçu voter code?",
        'code_resent': "Le code a été renvoyé",
        'verify_code_label': 'Vérification de code',
        'verify_label': 'Vérification',
        'reload': 'rechargement',
        "remember_me": "Se souvenir de moi?",
        'current_password': "Mot de passe actuel",
        'new_password': "Nouveau de passe",
        'confirm_new_password': "Confirmé votre mot de passe",
        'password_successfully_changed': "mot de passse changé avec succès",
        'change_password': "Changer de mot de passe"
    },
    'menu': {
        'dashboard': 'Tableau de bord',
        'operator': 'Opérateur',
        'send_balance': 'Envoyez une recharge',
        'buy_gift_card' : 'Acheter une carte cadeau',
        'auto_balance': 'recharge automomatique',
        'order_history': 'Historique de commande',
        'order_summary': 'Sommaire de commande',
        'receipt': 'Reçu',
        'support': 'Support',
        'store_locator': 'Point de vente',
        'logout': 'deconnexion',
        'login': 'connexion',
        'register': 's’inscrire',
        'number': 'Nombre',
        'order': 'Commande',
        'summary': 'Sommaire',
        'payment': 'Paiement',
        'verify_code': 'Vérificaton de code',
        'change_password': "Changer de mot de passe",
        'forgot_password': 'Mot de passe oublie',
        'forgot_password_confirm': 'Confirmation de mot de passe oublié',
        "support_tickets": "support des tickets",
        "reward_points": "Points de récompense",
        "account": "Compte",
        "contact_list": "liste de contact",
        "manage-payments": "option de moyen de paiment",
        "stored-cards" : "Cartes de crédit sauvegardées",
        "checkout-as-guest" : "Commander En Tant Qu'invité",
        "guest-email" : "Email de L'invité",
        "note":"Remarque : Les cartes associées à des profils récurrents ne peuvent pas être supprimées",
    },
    'home': {
        'welcome': 'Bienvenue chez Etopup online'
    },
    'send_balance': {
        'no_country_found': "Pays non trouvé",
        'confirm_password_label': 'Confirmer le mot de passe',
        'password_label': 'Mot de passe',
        'user_name_label': 'adresse e-mail',
        'signup_button': 'bouton de signature',
        'pay_button_title': 'paiement',
        'checkout_button_title': 'Passer à la caisse',
        'next_button_title': 'suivant',
        'mobile_number_placeholder': 'Numéro de mobile',
        'credit_card_number': "Numéro de carte bancaire",
        'from_credit_card': 'De la carte bancaire',
        'from_paypal': 'De Paypal',
        'from_reward_points': "Point de fidélité",
        'auto_balance_title': 'Recharge automatique',
        'balance_pending': 'Recharge en attente',
        'repeat_button_title': 'Recommencer',
        'repeat_transaction': "Transaction répété",
        'debit_credit_placeholder': "Carte Credit/Debit",
        'card_number_placeholder': 'Numéro de carte Credit/Debit',
        'expiration_date_placeholder': "date d'expiration",
        'cvv_placeholder': 'CVV',
        'full_name_placeholder': 'Nom complet',
        'billing_address_placeholder': 'Adresse de facturation',
        'street_address_placeholder': 'Rue',
        'city_placehoder': 'Ville',
        'postal_code_placeholder': 'Code postal',
        'state_placeholder': 'Etat',
        'country_placeholder': 'Pays',
        'find_credit_card_number': 'OU PUIS JE TROUVER MON NUMERO DE CARTE BANCAIRE',
        'stored_credit_card': "Enregistrement Credit/Debit",
        'stored_cc_future': "Enregistrement Credit/Debit pour de prochaine utilisation",
        'new_card_type': 'Nouvelle carte de Credit/Debit',
        'select_card_type': 'Slectionner Credit ou Debit',
        'transaction_id': 'Transaction: # {{transactionId}}',
        'balance_failed': 'Rechargement echoué',
        'recharge_to': 'Recharger à',
        'failed': 'echec',
        'pending': 'attente',
        'check_valid_number_1': 'SVP verifier si validité',
        'check_valid_number_2': 'nombre et essayer encore',
        'balance_success': 'rechargement avec succès',
        'label_trasaction': 'Transaction: ',
        'incorrect_phone_number': "votre numéro de telephone n'est pas correcte, merci de réessayer!",
        'ok': 'OK',
        'view_all_link': 'Voir tout',
        'balance_phone_number_label': 'Numéro de rechargement',
        'exchange_rate_label': 'Taux de change',
        'select_amt_label': 'Sélectionner la recharge',
        'select_operator': "Sélectionner l'opérateur",
        'select_sku': 'Sélectionner le montant',
        "search_country": "Rechercher le pays",
        'click_select_country': 'Cliquer ici pour selectionner le pays',
        'select_country': 'Merci sélectionner le pays',
        'select_country_placeholder': 'Sélectionner le pays',
        'enter_mobile_number': "Merci de saisir le numéro de mobile",
        'operator_missing': "Merci de sélectionner l'opérateur.",
        'amount_missing': 'Merci de sélectionner le montant.',
        'coupon_code_label': 'Code de coupon',
        'reward_points_label': 'Points de récompense',
        'coupon_apply_label': 'renseigner',
        'coupon_applied_message': `insérer le code coupon. vous recevrez un bonus de {{discount}} {{currency}}.`,
        'cover_sales_tax_message': `Je souhaite couvrir la taxe et envoyer {{currencyCode}} {{faceValue}} au téléphone.`,
        'reward_points_message': `Vous disposez de {{reward}} points de fidélité ({{discount}} {{currency}}). Vous pouvez utiliser jusqu'à {{discountTopup}} {{currency}} pour cette recharge.`,
        'zero_amount_payment_message': "'félicitations!vous avez....points pour payer cette recharge.Vous n'aurez rien à payer",
        'paypal_message': "Vosu avez selectionnez paypel comem paimeent.lorsque vous appuez sur Paiement, vous serez rediriger sur Paypal pour effectuer le paiement.",
        "payment_sub_heading": "",
        "topup_heading":"Envoyé une recharge",
        "topup_sub_heading": "Renseigner le numéro de téléphone que vous souhaitez recharger",
        "viva_disclaimer": "Les recharges de cette application sont disponibles pour les cartes de crédit dans E.E.U.U. Pour une utilisation nationale, République dominicaine, les montants seront facturés en USD",
        "select_value" : "Choisissez une valeur",
        "giftcard_delivery_disclaimer" : "La carte-cadeau sera livrée au destinataire par e-mail et SMS. Veuillez vous assurer que ces informations sont correctes. Cela ne peut pas être changé après la vente.",
        "enter_recipient_details": "Entrer les détails du bénéficiaire",
        "recipient_mobile" : "Numéro de mobile du bénéficiaire",
        "recipient_email" : "Destinataire e-mail",
        "confirm_recipient_email" : "Confirmer l'email du bénéficiaire",
        "recipient_name" : "Nom complet du bénéficiaire",
        "recipient_message" : "Message au bénéficiaire",
        "sender_details" : "Entrer les détails de l'expéditeur",
        "sender_mobile": "Numéro de mobile de l'expéditeur",
        "sender_name" : "Nom complet de l'expéditeur",
        "gift_card" : "Carte cadeau",
        "purchase_failed" : "Achat raté",
        "purchase_pending": "Achat en attente",
        'purchase-timeout': "Délai d'achat",
        "reward_code_applied": "Code de récompense appliqué",
        "enter_reward_code" : "Entrez le code de récompense",
        "store_pin_payment_msg" :"Toutes nos félicitations! Vous ne serez pas facturé pour cette transaction. Veuillez vérifier votre e-mail pour le reçu."
    },
    'auto_balance': {
        'topup_day': "recharge du jour",
        'signup_button': 'accepter',
        'auto_balance_header': 'Recharge automatique',
        'no_profile_msg': 'Pas de recharge automatique disponible. Merci de sélectionner le bouton ci dessous pour effectuer un nouveau rechargement automatique.',
        'new_profile_button_title': 'Nouveau rechargement automatique',
        'back_to_home_title': 'Retour au menu',
        'frequency_30days': '30 jours',
        'frequency_15days': '15 jours',
        'frequency_7days': '7 jours',
        "week": "semaine",
        "month": "mois",
        'enable_profile_button_title': 'Rechargement automatique disponible',
        'frequency_label': 'fréquence',
        'balance_amount_label': 'Montant de la recharge',
        'auto_balance_cancel_fail': "Nous sommes désolés.une erreur est survenu qui a annulé voter commande",
        'auto_balance_success': 'Rechargement automatique créé avec succès',
        'auto_balance_cancelled': 'rechargement automatique annulé',
        'frequency_days': 'chaque {{frequencyDays}} jours',
        'active_auto_topup_status': '{{frequency}} on {{topupDayString}}',
        'terms_and_conditions_msg': 'En cliquant sur commander, vous acceptez',
        'terms_and_conditions_link': 'conditions générales',
        'proceed_with_for_payment': 'processus de paiement en cours',
        'plus_bonus': '+ Bonus',
        'bonus_data': '& {{bonusData}} donnée',
        'profile_created': 'Rechargement automatique créé',
        'cancel_message': `Etes vous sur de vouloir annuler le rechargement automatique +{{internationalCode}} {{localMobileNumber}} ?`,
        'schedule': "Calendrier : chaque {{freq}} jour du mois et ceci à compter du  {{topupDayString}} à partir de {{startDateFormated}}.Remarque : vous pouvez annuler le rechargement automatique à tout moment. Aucune question posée.",
        'schedule_short': "Chaque {{freq}} sur {{topupDayString}} à partir de {{startDateFormated}}.",
        'starting': 'Commençant',
        'contact_number': `Numéro de contact de l'expéditeur`,
        'contact_number_missing' : `Veuillez saisir le numéro de contact de l'expéditeur.`
    },
    'receipt': {
        'recipient': 'Destinataire',
        'price': 'Prix',
        'balance': 'Montant total',
        'less_tax': 'Moins de taxe ',
        'bonus_balance': 'Bonus de recharge',
        'bonus_data': 'Donnée de bonus',
        'bonus_validity': 'validité de {{bonusValidity}} jours',
        'bonus_data_validity': 'validité de bonus de {{bonusValidity}} jours',
        'total_balance': 'Montant total rechargé',
        'total_data': 'Total de donnée',
        'processing_fee': 'Frais de Commodité',
        'total_payment': 'Total paiement',
        'promo_code_label': "Code promo",
        'promo_code_applied': 'Inséré le code promo',
        'promo_code_discount_label': 'Discount (code promo)',
        'reward_point_discount_label': 'Récompense de points',
        'sms_charge': 'frais de SMS',
        'send_sms': "Envoyé un SMS personnalisé",
        'sms_fee': "Des frais de {{fee}} cents s'appliquent",
        'i_have_coupon': "Ai un code coupon ",
        'transactionNotCompleted': `Nous sommes désolés, mais la transaction n'a pas été effectuée pour <strong> {{productName}} </strong> numéro de mobile <strong> + {{internationalCountryCode}} {{mobileNumber}},</strong> dans la quantité <strong> {{faceValue}} </strong>.`,
        'transactionInProcess': `Votre transaction pour <strong> {{productName}} </strong> numéro de portable <strong> + {{internationalCountryCode}} {{mobileNumber}} </strong>, correspondant à <strong> {{faceValue}} </strong>, est en train de se réaliser.`,
        'transactionPaymentSuspended': `Votre transaction pour <strong> {productName} </strong> numéro de portable <strong> + {{internationalCountryCode}} {mobileNumber} </strong>, correspondant à <strong> {{faceValue}} </strong>, est pas encore terminé car le processeur de paiement n'a pas encore confirmé la réception des fonds.`,
        'transactionNoCharge': "Vous n'avez pas été facturé pour cette transaction en attente.",
        'supportMessage': `Si vous avez des questions, veuillez nous contacter via la page <a href="#/tickets"> Tickets d'assistance </a> ou le bouton Support ci-dessous.`,
        'supportTickets': `Support Tickets`,
        'checkMobileNumber': "merci de vérifier voter numéro de mobile, l'opérateur et essayé encore.",
        'dataPlanAlreadyActive': "Désolé, cette transaction ne peut pas être effectuée car le forfait de données est déjà activé et n'a pas expiré.",
        'notificationEmail': `Un e-mail de notification a été envoyé à <strong> {{userEmail}} </strong>. Notez le numéro de transaction <strong> {{transactionId}} </strong> pour toute référence ultérieure.`,
        'customerServiceDilligent': `Notre équipe de support client travaille avec diligence pour réaliser cette transaction et peut vous contacter pour vérification. Vous ne serez débité que lorsque la transaction sera complétée avec succès.`,
        'customerServicePaymentProcessor': `Notre customer support se charge de la transaction. vosus erez notifier lorsque la transaction sera finalisée.`,
        'notify': `Nous vous notifirons lorsque la transation sera compléte.`,
        'net_charge': "Charge nette",
        'topup-timeout': "dépassement de temps",
        'topup-timeout-msg-1': "Nous sommes désolés. Malheureusement la connection a echoué.",
        'topup-timeout-msg-2': "Nous essayons de contacter le serveur. Soyez assuré que si la transaction n'aboutit pas, vous ne serez pas facturé pour la transaction.",
        'topup-timeout-msg-3': "Une fois que nous aurons reçu une réponse du serveur, nous nous dirigerons vers la réception de votre transaction.",
        'topup-timeout-msg-4': "Redirection en moins de <strong> {{secondesLeft}} secondes </strong>",
        'amount_charged': "Montant facturé",
        'from_paypal': "De Paypal",
        'from_cc': "À la carte de crédit",
        'deliver_to': "Livrer à",
        'delivery_email' : "Email",
        'delivery_mobile' : "Mobile",
        'delivery_message' : "Message",
        'resend_email' : "E-mail renvoyé",
        'amount' : "Montant",
        "transactionNotCompleted_giftcard": `Nous sommes désolés, mais la transaction n'a pas été effectuée pour la carte-cadeau <strong> {{productName}} </strong>, d'un montant de <strong> {{faceValue}} </strong>.`,
        'transactionInProcess_giftcard': `Votre transaction pour la carte-cadeau <strong> {{productName}} </strong>, d'un montant de <strong> {{faceValue}} </strong>, est en cours d'exécution.`,
        'guest_email_address' : "Email d'adresse de l'invité"
    },
    'support': {
        'signup_button': 'enregisterment',
        'email_alert_msg': 'Merci de nous écrire {{supportEmail}}',
        'email_us_button_title': 'Ecrivez nous',
        'chat_button_title': 'Discussion'
    },
    'constants': {
        'welcome': 'Bienvenue chez eTopup Online',
        'exit_app': "souhaitez vous quitter l'application?",
        'auth_failed': 'Authentification annulé ou échoué',
        'network_error': 'Erreur de réseau, merci de vérifier votre connexion internet et réessayé.',
        'payment_network_error': "Erreur de réseau. en raison d'une erreur la plateforme n'est pas en mesure de vous communiquer le statut de votre recharge. si votre recharge est exécuté, vous le verrez en haut de votre écran.",
        'auto_profile_network_error': "En raison d'une erreur la plateforme n'est pas en mesure de vous communiquer le statut de votre profil. Merci de vous rendre à la page menu. si votre profil est enregistré, vous le verrez dans la page menu.",
        'general_network_error': 'Une erreur technique est seuvenu. merci de réessayer.',
        'empty_balance_history_msg': "Merci d'avoir choisieTopupOnline.com.soyé pret pour envoyé des recharges et crée l'historique!",
        'enter_number_for_balance': 'Saississez le numéro que vous souhaitez recharger',
        'no_network_message': 'Pas de conenxion internet. Verifier votre conenxion et appuyer sur RECHARGEMENT pour continuer',
        'selecte_provider': 'Merci de selectionner votre fournisseur',
        'exclusive': 'Exclusif',
        'online_offer': 'Offre en ligne',
        'loading_msg': 'Merci de patienter...',
        'check_app_version_msg': 'Vérification de la verson en ligne',
        'app_update_message': "App update!', 'Une nouevlle version de l'application a été mise à jour",
        'loading_user_settings_msg': 'Téléchargement, Merci de patienter...',
        'loading_recent_trx_msg': 'Téléchargement récent des transactions et du profil, Merci de patienter...',
        'contact_permissions_title': 'Autorisation de contact',
        'contact_permission_message': "{{appName}} l'application a besoin d'accéder à vos contacts, vosu pourrez ainsi sélectionner un conatct pour le recharger.",
    },
    'common': {
        'recharge': 'Recharge',
        'cancel_button': 'Annulation',
        'cancelled': 'Annulé',
        'active': "Actif",
        'rejected': "Rejeté",
        'ok_button': 'OK',
        'sales_tax': 'Taxe',
        "extra": "extra",
        "pay": "Payer",
        "checkout": "Procéder au paiement",
        "next": "Suivant",
        "language": "Langue",
        "menu": "Menu",
        "close": "Fermeture",
        "ending": "Fin",
        "type": "Type",
        "question": "Question",
        "issue": "Issue",
        "subject": "Sujet",
        "description": "La description",
        "submit": "Soumettre",
        "oops": "Oops..",
        "save": "Sauvergarder",
        "top-up": "Recharge",
        "edit": "Imprimer",
        "remove": "Supprimer",
        "select_state": "Selectionner l'état",
        "hello": "Bonjour",
        "policy": "Politique",
        "plan": "Plan de données",
        "new": "Nouveau",
        "notification-subscribe-button" : "S'abonner",
        "notification-unsubscribe-button" : "Se désabonner",
        "notification-text" : "S'abonner pour recevoir des alertes lorsque le statut de la transaction change, et aussi pour recevoir des nos promotions et offres exceptionnelles."
    },
    'error': {
        'validation_error': 'La donnée est incomplète ou invalide.',
        'error_mobile_number': 'Merci de corriger le numéro de mobile.',
        'error_credit_card': 'Merci de vérifier les informations de la carte bancaire.',
        'user_locked': 'Utilisateur invalide est bloqué. merci de contacter le service support.',
        'registration_problem': "Il y a eu un problème lors de l'enregistrement.merci de réessayer.",
        'error_forgot_password': "l'adresse e-mail n'est pas enregsitré chez nous",
        'reward_points_limit_error_message': `Le monatant maximum est {{discount}} {{currency}}`,
        'reward_points_min_limit_error_message': `Le montant minimum est {{discount}} {{currency}}`,
        'reward_points_invalid_number': 'Merci de renseigner un numéro valide',
        'general_error': "Erreur. Merci de réessayer",
        'error_contact_support': "Nous sommes désolés. des erreurs sont survenus lors de l'opération."
    },
    'messages': {
        'reset_password_email_1': 'Nous vous avons envoyé un e-mail avec un lien pour changer votre mot de passe. Cliquez sur le lien et suivez la procédure. Après avoir effectué le changement de mot de passe, vous pourrez continuer à effectuer des transactions.',
        'reset_password_email_2': 'Après avoir effectué le changement de mot de passe, vous pourrez continuer.',
        'verification_success': 'Code de vérification accepté. vous allez être rediriger pour vous connecter.',
        'code_sent': 'Codé envoyé avec succès.',
        'verification_code_sent_1': 'Un e-mail contenant un code de vérification a été expédié',
        'verification_code_sent_2': "Merci de verifier votre e-mail (ou dans vos indésirables); copier le code dans la cadre réservé et valider.",
        'different_currency': `Nous avons détecté que vous avez déjà effectué des transactions dans {{homeCurrency}}, alors que la transaction en cours
        est libellé en {{trxCurrency}}. Vous avez le choix de payer en {{homeCurrency}}. S'il vous plaît, dites-nous comment vous souhaitez procéder`,
        'pay_in_curr': "Paiement avec {{currency}}"
    },
    'social': {
        'error_play_service': 'Service Google ne fonctionne pas....',
        'error_google': 'Erreur Google',
        'sign_in_cancel': 'Enregistrement annulé',
        'sign_in_facebook': 'Snregistrement avec Facebook',
        'sign_in_google': 'Enregistrement avec Google'
    },
    'validations': {
        'mobile_number_length': "Voter numéro de mobile doit avoir {{length}} chiffres",
        'mobile_number_invalid': "Merci de renseigner un numéro valide",
        'user_name_required': 'Email demandé',
        'valid_email': 'Merci de renseigner un email valide',
        'password_required': 'Mot de passe demandé',
        'current_password_required': 'Mot de passe actuel demandé',
        'password_char_length': 'Mot de passe doit contenir 6 caractéres',
        'pass_rule_2': 'Mot de passe doit avoir une lettre minuscule',
        'pass_rule_3': 'Mot de passe doit avoir une lettre majuscule',
        'pass_rule_4': 'Mot de passe doit avoir un chiffre numérique',
        'password_char_type': 'Mot de passe doit avoir au moins une lettre minuscule.',
        'password_message': 'Mot de passe doit avoir au moins 6 caractères,  au moins une minuscule, une majuscule et un chiffre.',
        'confirm_password': 'Les mot de passe doivent correspondrent',
        'confirm_password_short': 'mot de passe corerspondant',
        'error_type_validation': 'Erreur survenue à la vaildation {{type}} token',
        'invalid_user_name': 'nom invalide.',
        'username_already_taken': 'nom déjà utilisé.',
        'invalid_id_pass': 'invalide nom ou mot de passe',
        'valid_verification_code': 'Merci de renseigner un code valide',
        'invalid_code': 'Code invalide',
        'credit_card_required_validation': 'numéro de carte a renseigné',
        'credit_card_validation': 'Merci de renseigner un numéro de carte valide',
        'month_required_validation': 'MM/AA demandé',
        'month_validation': 'MM/AA invalide',
        'cvv_required_validation': 'CVV est demandé',
        'cvv_validation': 'invalide CVV',
        'select_credit_card': 'Merci de selectionner votre carte de crédit',
        'full_name_required': 'Nom complet est demandé',
        'street_address_required': 'Adresse est demandé',
        'city_required': 'Ville est demandé',
        'state_required': 'etat est demandé',
        'country_required': "Pays est demandé",
        'zip_required': 'Code postal est demandé',
        'zip_validation': 'Merci de renseigner un code postal valide',
        'required_validation': '{{name}} est demandé',
        'email_validation': '{{name}} doit etre un email valide',
        'min_length_validation': '{{name}} doit être avec au moins {{length}} caracttères',
        'max_length_validation': '{{name}} doit être avec moins de {{length}} caracttères',
        'lower_case_validation': '{{name}} doit être avec au moins une minuscule',
        'upper_case_validation': '{{name}} doit être avec au moins uen majuscule',
        'numeric_validation': '{{name}} doit être avec au moins un signe distinctf',
        'invalid_validation': '{{name}} est invalide',
        'coupon_code_lenght_validation': 'Le code coupon doit contenir 5 caractères minimum',
        'coupon_code_validation': 'Merci de renseigner un code coupon valide',
        'coupon_code_applied': 'Code coupon renseigné avec succès',
        'reward_points_applied_success': 'Vos points renseignés avec succès',
        'reward_points_applied': `Félicitations ! vous utilisez {{rewardPointsUsed}} vos points pour le rechargement. vous serez rechargé avec un montant net de {{netCharge}} {{currency}}.`,
        'reward_points_applied_full_amount': `Félicitations ! vous utilisez {{rewardPointsUsed}} vos points pour cette recharge. vous ne serez pas rechargé.`,
        'mobile_number_required': "Numéro de mobile demandé",
        'operator_required': "Opérateur demandé",
        'recipient_mobile_required' : `Le mobile du destinataire est requis`,
        'recipient_email_required' : `L'adresse e-mail du destinataire est obligatoire`,
        'recipient_name_required' : `Le nom complet du destinataire est obligatoire`,
        'sender_name_required' : `Le nom complet de l'expéditeur est obligatoire`,
        'sender_mobile_required' : `Le mobile de l'expéditeur est requis`,
        'recipient_email_confirm' : `L'adresse e-mail du destinataire et l'e-mail de confirmation doivent correspondre`,
        'enter_valid_recipient_info' : `Veuillez saisir les informations correctes du destinataire et de l'expéditeur`,
        'guest_email_required' : 'Le champ Email del’ invité est obligatoire',
    },
    "myaccount": {
        'createdOnLabel': 'créé le',
        'updatedOnLabel': 'mise à jour le',
        'statusLabel': 'statut',
        "new_contact": "Créer un nouveau contact",
        "edit_contact": "Modifier le contact",
        "contact_saved": "Contact sauvergardé avce succès",
        "new_comment": "Nouveau commentaire",
        "post_comment": "Poster vos commentaires ici",
        "new_ticket": "Créer un nouveau ticket",
        "no_ticket": "Vous n'avez pas de ticket en cours.",
        "no_auto_topup": "Vous n'avez pas de recharge en cours",
        "no_topup": "Vosu n'avez pas de recharge",
        "no_ticket_message": "Si vous avez une question, cliquez  <a href='#/ticket/new'>ici</a> pour lancer un nouveau ticket.",
        "error_subject": "Merci de renseigner le sujet",
        "error_description": "Merci de renseigner la description",
        "ticket_created": "Voter ticket a été créé.",
        "comments_posted": "Votre commentaire a été psoté avec succès",
        "ticeket_detail": "Détail du ticket",
        "delete-auto-topup-confirm-message": "Etes vous de vouloir annuler le rechagement automatique",
        "delete-contact-confirm-message": "Etes vous de vouloir annuler ce contact",
        "review-history": "menu historique",
        "reward-point-balance-msg": "vous avez {{rewardPointBalance}} points.",
        "date": "Date",
        "points_earned": "Points gagnés",
        "points_used": "Points utilisés",
        "balance": "Balance",
        "reward_points_policy":"politique de points de récompense",
        "delete_stored-card-message" : "Êtes-vous sûr de vouloir supprimer cette carte de crédit?"
    }
};